export default '/pricing/windows-store';
